import { apiClient } from '@/client'

export default {
  namespaced: true,
  state: {
    navDrawer: true,
    mapCenter: { lat: 36.7073172, lng: 2.8451244 },
    mapZoom: 7,
    settings: {
      cacheExpire: 0,
      notifPoll: 0,
      useSoftAvailability: false,
      includeArchive: false,
    },
  },
  getters: {
    navDrawer: state => state.navDrawer,
    navMenu: state => state.navMenu,
    mapCenter: state => state.mapCenter,
    mapZoom: state => state.mapZoom,
    cacheExpire: state => state.settings.cacheExpire,
    notifPoll: state => state.settings.notifPoll,
    useSoftAvailability: state => state.settings.useSoftAvailability,
    includeArchive: state => state.settings.includeArchive,
    loggedIn: state => state.loggedIn,
  },
  mutations: {
    TOGGLE_DRAWER (state) {
      state.navDrawer = !state.navDrawer
    },
    UPDATE_MAP_CENTER (state, position) {
      state.mapCenter = position
    },
    UPDATE_MAP_ZOOM (state, mapZoom) {
      state.mapZoom = mapZoom
    },
    UPDATE_CACHE_EXPIRE (state, cacheExpire) {
      state.settings.cacheExpire = cacheExpire
      apiClient.setCacheExpire(cacheExpire)
    },
    UPDATE_NOTIF_POLL (state, notifPoll) {
      state.settings.notifPoll = notifPoll
    },
    UPDATE_SOFT_AVAILABILITY (state, useSoftAvailability) {
      state.settings.useSoftAvailability = useSoftAvailability
    },
    UPDATE_INCLUDE_ARCHIVE (state, includeArchive) {
      state.settings.includeArchive = includeArchive
    },
    LOAD_STATE (state) {
      console.log('attempting to load local state')
      let jsonConfigs = localStorage.getItem('_gespanui')
      if (jsonConfigs) {
        let payload = JSON.parse(jsonConfigs)
        state.settings.cacheExpire = payload.cacheExpire
        state.settings.useSoftAvailability = payload.useSoftAvailability
        state.settings.includeArchive = payload.includeArchive
        state.settings.notifPoll = payload.notifPoll
        apiClient.setCacheExpire(payload.cacheExpire)
        console.log('local state loaded')
      } else {
        console.log('no local state found')
      }
    },
    DUMP_STATE (state) {
      let jsonConfigs = JSON.stringify(state.settings)
      localStorage.setItem('_gespanui', jsonConfigs)
    },
  },
  actions: {
    toggleDrawer: ({ commit }) => {
      commit('TOGGLE_DRAWER')
    },
    updateMapCenter: ({ commit }, payload) => {
      commit('UPDATE_MAP_CENTER', payload)
    },
    updateMapZoom: ({ commit }, payload) => {
      commit('UPDATE_MAP_ZOOM', payload)
    },
    updateCacheExpire: ({ commit }, payload) => {
      commit('UPDATE_CACHE_EXPIRE', payload)
    },
    updateNotifPoll: ({ commit }, payload) => {
      commit('UPDATE_NOTIF_POLL', payload)
    },
    updateSoft: ({ commit }, payload) => {
      commit('UPDATE_SOFT_AVAILABILITY', payload)
    },
    updateArchive: ({ commit }, payload) => {
      commit('UPDATE_INCLUDE_ARCHIVE', payload)
    },
    loadState: ({ commit }) => {
      commit('LOAD_STATE')
    },
    saveState: ({ commit }) => {
      commit('DUMP_STATE')
    },
  },
}
